import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mt-2 space-y-2 border-t border-gray-300 py-2" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "flex-1 font-semibold" }
const _hoisted_4 = { class: "gap-4 space-y-4 md:grid md:grid-cols-3 md:space-y-0" }
const _hoisted_5 = {
  for: "rangeAnswer",
  class: "mb-2 block text-sm font-medium text-gray-800"
}
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = { class: "mb-2 block text-sm font-medium text-gray-800" }
const _hoisted_8 = {
  key: 0,
  class: "text-danger bg-danger-100 p-2 text-sm shadow"
}
const _hoisted_9 = {
  key: 1,
  controls: "",
  class: "mt-2 w-full"
}
const _hoisted_10 = ["src"]

import { computed, reactive, ref, watch, onMounted } from 'vue';
import { useVuelidate, ValidationArgs } from '@vuelidate/core';
import { VaultService } from '@/services';
import { toastServiceError } from '@/services/core/notification';
import { getAudioFormat } from '@/utils/audio';
import { TrashIcon } from '@heroicons/vue/solid';

import { required, requiredIf, maxLength } from '@/utils/validators';
import { ConnectFlowSurveyQuestionFormState, MultiSelectOption } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConnectFlowSurveyQuestionForm',
  props: {
    modelValue: {
        type: Object as () => ConnectFlowSurveyQuestionFormState,
        required: true,
    },
    index: {
        type: Number,
        required: true,
    },
    showRemove: {
        type: Boolean,
        required: true,
    },
},
  emits: ['update:modelValue', 'remove'],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const audioPreview = ref<string | null>(null);

const scoreOptions = [
    { label: '0-5', value: '0-5' },
    { label: '0-9', value: '0-9' },
    { label: '0-10', value: '0-10' },
    { label: '1-2', value: '1-2' },
    { label: '1-5', value: '1-5' },
    { label: '1-9', value: '1-9' },
    { label: '1-10', value: '1-10' },
] as MultiSelectOption[];

const formState = reactive<ConnectFlowSurveyQuestionFormState>(props.modelValue);

const rules = computed<ValidationArgs<ConnectFlowSurveyQuestionFormState>>(() => ({
    _key: {},
    label: { required, maxLength: maxLength(500) },
    rangeAnswer: { required },
    audioFile: {},
    textToAudio: {
        required: requiredIf(() => !formState.audioFilePath),
        maxLength: maxLength(500),
    },
    audioFilePath: {
        required: requiredIf(() => formState.textToAudio?.length === 0),
    },
}));

const v$ = useVuelidate(rules, formState);

__expose({
    validate: () => v$.value.$validate(),
});

// Load audio preview for edit mode
const loadAudio = async () => {
    if (formState.audioFilePath) {
        try {
            const { data } = await VaultService.getAudioAsset(formState.audioFilePath);
            const blob = new Blob([data], { type: getAudioFormat(formState.audioFilePath) });
            formState.audioFile = new File([blob], formState.audioFilePath, {
                type: blob.type,
                lastModified: Date.now(),
            });
        } catch (e) {
            toastServiceError(e);
        }
    }
};

// Handle file selection
watch(
    () => formState.audioFile,
    () => {
        if (formState.audioFile) {
            formState.audioFilePath = formState.audioFile.name;
            audioPreview.value = URL.createObjectURL(formState.audioFile);
            formState.textToAudio = '';
        } else {
            formState.audioFilePath = '';
            audioPreview.value = null;
        }
    },
);

watch(
    formState,
    () => {
        emit('update:modelValue', formState);
    },
    {
        deep: true,
    },
);

onMounted(loadAudio);

return (_ctx: any,_cache: any) => {
  const _component_UiActionButton = _resolveComponent("UiActionButton")!
  const _component_UiTextInput = _resolveComponent("UiTextInput")!
  const _component_UiMultiselect = _resolveComponent("UiMultiselect")!
  const _component_UiTextArea = _resolveComponent("UiTextArea")!
  const _component_UiAudioUpload = _resolveComponent("UiAudioUpload")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(`${_ctx.$t('connectFlowSurvey.form.labels.question')} ${__props.index + 1}`), 1),
      (__props.showRemove)
        ? _withDirectives((_openBlock(), _createBlock(_component_UiActionButton, {
            key: 0,
            variant: "danger",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('remove', __props.index)))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(TrashIcon), { class: "h-5 w-5" })
            ]),
            _: 1
          })), [
            [_directive_tippy, _ctx.$t('connectFlowSurvey.form.actions.removeQuestion')]
          ])
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_UiTextInput, {
        modelValue: _unref(v$).label.$model,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).label.$model) = $event)),
        name: "label",
        type: "text",
        label: _ctx.$t('connectFlowSurvey.form.labels.label'),
        class: "col-span-2",
        errors: _unref(v$).label.$errors,
        onBlur: _unref(v$).label.$touch
      }, null, 8, ["modelValue", "label", "errors", "onBlur"]),
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('connectFlowSurvey.form.labels.scoreRange')), 1),
        _createVNode(_component_UiMultiselect, {
          name: "rangeAnswer",
          modelValue: formState.rangeAnswer,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formState.rangeAnswer) = $event)),
          primitive: "",
          options: scoreOptions,
          errors: _unref(v$).rangeAnswer.$errors
        }, null, 8, ["modelValue", "errors"])
      ]),
      _createVNode(_component_UiTextArea, {
        id: "textToAudio",
        name: "textToAudio",
        modelValue: formState.textToAudio,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formState.textToAudio) = $event)),
        label: _ctx.$t('connectFlowSurvey.form.labels.textToAudio'),
        placeholder: _ctx.$t('connectFlowSurvey.form.labels.textToAudioPlaceholder'),
        rows: 4,
        disabled: formState.audioFile != undefined,
        errors: _unref(v$).textToAudio.$errors,
        class: "col-span-2"
      }, null, 8, ["modelValue", "label", "placeholder", "disabled", "errors"]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('connectFlowSurvey.form.labels.audioUpload')), 1),
        _createVNode(_component_UiAudioUpload, {
          file: formState.audioFile,
          "onUpdate:file": _cache[4] || (_cache[4] = ($event: any) => ((formState.audioFile) = $event)),
          "text-rule": _ctx.$t('connectFlowSurvey.form.labels.uploadRules'),
          errors: _unref(v$).audioFilePath.$errors
        }, null, 8, ["file", "text-rule", "errors"]),
        (_unref(v$).audioFilePath.$errors && _unref(v$).audioFilePath.$errors.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).audioFilePath.$errors, (error) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: error.$uid
                }, _toDisplayString(error.$message), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (audioPreview.value)
          ? (_openBlock(), _createElementBlock("audio", _hoisted_9, [
              _createElementVNode("source", { src: audioPreview.value }, null, 8, _hoisted_10),
              _cache[5] || (_cache[5] = _createTextVNode(" Your browser does not support the audio element. ", -1))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})